import React, { CSSProperties } from "react"

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string,
    message?: string,
    touched?: boolean,
    error?: boolean
    containerStyle?: CSSProperties
    inputClassName?: string
}


const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
    ({ label, message, error, required, containerStyle, className, inputClassName, ...inputProps }, ref) => {
        return (
            <div style={containerStyle} className={`input-container ${error ? "error" : ""} ${className ?? ""}`}>
                {label && (
                    <span className="input-label">
                        {label}
                        {required && "*"}
                    </span>
                )}
                <input
                    ref={ref}
                    className={`input ${inputClassName ?? ""}`}
                    required={required}
                    {...inputProps}
                />
                {message && <span className="input-message">{message}</span>}
            </div>
        );
    }
);

export default TextInput;